import { render } from "./IconSearchUp.vue?vue&type=template&id=156767d4"
import script from "./IconSearchUp.vue?vue&type=script&lang=js"
export * from "./IconSearchUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__